var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const parseISO_1 = __importDefault(require("date-fns/parseISO"));
const isValid_1 = __importDefault(require("date-fns/isValid"));
const getYear_1 = __importDefault(require("date-fns/getYear"));
const is_iso_date_1 = __importDefault(require("is-iso-date"));
const DOT_NET_UNSPECIFIED_DATETIME_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z?$/i;
function tryParseDate(val, options = {}) {
    if (!val || !(typeof val === 'string' || val instanceof String)) {
        return val;
    }
    try {
        const { lessRigorous } = options;
        const str = val;
        const needsToBeConverted = lessRigorous || // if true, skip this check
            (0, is_iso_date_1.default)(str) || // this will do a rigorous ISO8601 spec test
            DOT_NET_UNSPECIFIED_DATETIME_REGEX.test(str); // this is to cover how .net serializes "Unspecified" DateTimes
        if (needsToBeConverted) {
            const date = (0, parseISO_1.default)(str);
            if ((0, isValid_1.default)(date)) {
                return (0, getYear_1.default)(date) > 1 ? date : null;
            }
        }
    }
    catch (_a) { }
    return val;
}
exports.default = tryParseDate;
//# sourceMappingURL=tryParseDate.js.map